import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-circular-progressbar',
  templateUrl: './circular-progressbar.component.html',
  styleUrls: ['./circular-progressbar.component.scss'],
})
export class CircularProgressBarComponent implements OnInit {
  strokes = '100 ,100';
  strokeColor = 'stroke-green-400';

  @Input() value: number = 0;

  ngOnInit(): void {
    if (this.value > 0) {
      this.strokes = `${this.value} ,100`;
      return;
    }
    this.strokeColor = 'stroke-red-500';
  }
}
